var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookBlack = function SvgFacebookBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.564 6.318v2.036h3.646l-.395 3.25h-3.251V20H7.248v-8.395H5v-3.25h2.248V5.892c0-1.216-.091-1.793.426-2.735.516-.942 1.975-2.187 4.497-2.157s3.585.273 3.585.273l-.546 3.464s-1.61-.425-2.402-.273c-.79.151-1.244.638-1.244 1.853"
  })));
};
export default SvgFacebookBlack;